/**
 * TanStack Query hook for `GET /api/cro/metrics/funnel-pacing/CRO-05`
 * (Phase 04.1 #2). Feeds the CRO-05 Total Pipeline Funnel cumulative trend chart.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiFetch } from '../lib/api-client.js';

import type { MetricError } from './useCroScorecard.js';
import type { CroFunnelPacingResponse } from '@saledash/shared';

export function useCroFunnelPacing(): UseQueryResult<CroFunnelPacingResponse, MetricError> {
  return useQuery<CroFunnelPacingResponse, MetricError>({
    queryKey: ['cro', 'funnel-pacing', 'CRO-05'],
    queryFn: ({ signal }) =>
      apiFetch<CroFunnelPacingResponse>('/api/cro/metrics/funnel-pacing/CRO-05', { signal }),
    staleTime: 60_000,
    retry: 2,
  });
}
